<ejs-dialog #editTabSettingsWidget
            class="dialog-min-height"
            [isModal]="true"
            [showCloseIcon]="true"
            (close)="onCloseEditTabSettings()"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.home.dashboard.edit-tab' | translate}}
  </ng-template>
  <ng-template #content>
    <div class="row">
      <div class="col-4">
        <ejs-grid #grid
                  class="grid-with-toolbar"
                  width="100%"
                  rowHeight="38"
                  [editSettings]="editSettings"
                  [dataSource]="data"
                  (rowSelected)="onRowSelected($event)"
                  (actionBegin)="actionBegin($event)"
                  (actionComplete)="actionComplete($event)">
          <ng-template #toolbarTemplate let-data>
            <ejs-toolbar>
              <e-items>
                <e-item [text]="'i18n.domain.home.dashboard.add-tab' | translate" prefixIcon='e-icons icon-add' (click)="addTab()"></e-item>
              </e-items>
            </ejs-toolbar>
          </ng-template>
          <e-columns>
            <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
            <e-column field="name"
                      headerText="{{'i18n.domain.home.dashboard.edit-tabs-widget.tab-name' | translate}}"
                      clipMode="EllipsisWithTooltip"
                      type="string">
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
      @if (editForm) {
        <div class="col-8">
          <form id="tabSettingsForm" [formGroup]="editForm" autocomplete="off">
            <div class="form-row row">
              <div class="form-group col-12">
                <label for="name" class="control-label required">{{ 'i18n.domain.home.dashboard.edit-tabs-widget.tab-name' | translate }}</label>
                <input id="name" name="name" type="text" class="form-control" formControlName="name" autocomplete="off" />
                <app-error-messages [control]="editForm.controls.name"></app-error-messages>
              </div>
            </div>
            <!-- <div class="form-row row">
              <div class="form-group col-12">
                <label for="name" class="control-label required">{{ 'i18n.domain.home.dashboard.edit-tabs-widget.tab-name' | translate }}</label>
                <input id="name" type="text" class="form-control" formControlName="name" />
                <app-error-messages [control]="editForm.controls.name"></app-error-messages>
              </div>
            </div> -->
            <div class="row">
              <div class="col-3">
                <button class="btn  btn-outline-danger"
                        type="button"
                        (click)="deleteTabInfo()"
                        [hidden]="!editForm.value.id">
                  {{'i18n.shared.delete' | translate}}
                </button>
              </div>
              <div class="col-6">

              </div>
              <div class="col-3">
                <button class="btn btn-primary"
                        type="button"
                        [disabled]="editForm.invalid"
                        (click)="saveTabInfo()">
                  {{'i18n.shared.save' | translate}}
                </button>
              </div>

            </div>
          </form>
        </div>
      }
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary"
            type="button"
            (click)="onCloseEditTabSettings()">
      {{'i18n.shared.close' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
